// Tracks whether a Stripe card element is filled in well enough to submit.
//
// Both checkouts used to let the buyer press pay on a half-typed card: the
// token request then failed and Stripe's "your card number is incomplete"
// came back as a payment error, which is why over half of the client errors
// in the checkout log are incomplete-field messages rather than declines.
// Knowing completeness up front turns that into a disabled button and an
// inline hint.
//
// Shared by the Vue course checkout and the Alpine shop checkout so the two
// cannot drift on when the button unlocks.

// Stripe reports an unfinished field as an error on every keystroke, with an
// `incomplete_*` code. Those are not mistakes yet -- the buyer is mid-entry --
// so they are held back until the field loses focus. Every other code is a
// real validation failure and shows immediately.
const INCOMPLETE_CODE = /^incomplete/;

export function createCardCompletion() {
  return {
    complete: false,
    error: null,
    // The last incomplete-field message, held until blur.
    pendingError: null,

    handleChange(event = {}) {
      this.complete = Boolean(event.complete);

      const error = event.error;
      if (!error) {
        this.error = null;
        this.pendingError = null;
        return;
      }

      if (INCOMPLETE_CODE.test(error.code ?? "")) {
        this.pendingError = event.empty ? null : error.message ?? null;
        this.error = null;
        return;
      }

      this.pendingError = null;
      this.error = error.message ?? null;
    },

    handleBlur() {
      if (this.pendingError) this.error = this.pendingError;
    },

    reset() {
      this.complete = false;
      this.error = null;
      this.pendingError = null;
    },
  };
}
